//
//
//
//
//
//
//
//
//
//

export default {
	props:{
		disabled:{
			type:Boolean,
			default:false,
		},
        size: {
			type: String,
			default: '',
        },
		callback: {
			type: Object,
			default: null,
        },
        text: {
            default:'确认',
            type: String,
        },
	},
    computed:{
        style(){
            console.log(1111)
            let s = [];
            if(this.disabled){
                s.push('disabled');
            }
            if(this.size){
                s.push(this.size);
            }
            return s.join(" ");
        }
    },
	methods:{
		onConfirm(){
      		!this.disabled && this.$emit('on-confirm',this.callback);
		},
	},
}



// WEBPACK FOOTER //
// ./src/components/ui/buttonbox.vue